<template>
    <v-layout justify-center>
      <v-flex md12>
        <Changelog></Changelog>
      </v-flex>
    </v-layout>
</template>

<script>
import Vue from 'vue'
import Changelog from './module/changelog/Changelog'
export default {
  name: 'Newsbox',
  components: {Changelog},
  data () {
    return {
      currentItem: null
    }
  },
  methods: {
  },
  mounted () {
    // Vue.prototype.$api.checkCredentials(this) trans
    Vue.prototype.$api.getBreadCrumpModule({id: 'newsbox', text: 'Newsbox', href: '/#/di/Newsbox'})
    Vue.prototype.$eventHub.$emit('OnGetModuleTitle', Vue.i18n.translate('LABEL_MODULE_NEWSBOX')) //LABEL_MODULE_PASSWORD_RESET
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Newsbox.vue